import { Col, Form, FormItemProps, Input, Row } from "antd";
import { IDadosBancarioFormInstanceType } from "./DadosBancarioFormBasic";
import DadosBancarioTipoSelect from "./Tipo/DadosBancarioTipoSelect";
import { BooleanProps } from "@/utility-types";
import { EnumDadoBancarioTipo } from "@/Models/Pessoa/dadosBancario/DadosBancarioTipo";
import BancoSelect from "../../Financeiro/Conta/Agencia/Banco/BancoSelect";
import { DadosBancarioConta } from "@/Models/Pessoa/dadosBancario/DadosBancarioConta";
import DadosBancarioPix from "@/Models/Pessoa/dadosBancario/DadosBancarioPix";

export interface IDadosBancarioFormItemBasicProps extends FormItemProps<IDadosBancarioFormInstanceType> {
    codigo?:number,
    fieldsDisabled?:BooleanProps<IDadosBancarioFormInstanceType>
}
export default function DadosBancarioFormItemBasic({
    fieldsDisabled,
    codigo,
    value,
    id,
    ...rest
}:IDadosBancarioFormItemBasicProps) {
    const isAlteracao = codigo !== undefined && codigo !== null && !isNaN(codigo) && codigo > 0;
    const nameBase = id?.split('_')?.filter(f => f !== undefined && f !== null) ?? [];
    const nameParent = [nameBase?.findLast(f => true)].filter(f => f !== undefined && f !== null);
    const codTipoForm = value?.codTipo;//Form.useWatch([...nameBase, "codTipo"], form);

    return <Row gutter={8}>
        <Form.Item<IDadosBancarioFormInstanceType> name={[...nameParent, "codigo"]} hidden></Form.Item>
        <Form.Item<IDadosBancarioFormInstanceType> name={[...nameParent, "codPessoa"]} hidden></Form.Item>

        <Col xs={24} sm={8} md={5} lg={4} xl={3} xxl={3}>
            <Form.Item name={[...nameParent, "codTipo"]} label="Tipo" rules={[{ required : true }]}>
                <DadosBancarioTipoSelect disabled={isAlteracao ? true : fieldsDisabled?.dadosBancario?.codTipo} />
            </Form.Item>
        </Col>

        <Col xs={24} sm={16} md={10} lg={10} xl={6} xxl={6}>
            <Form.Item<IDadosBancarioFormInstanceType> name={[...nameParent, "descricao"]} label="Descrição" rules={[{ max: 128 }]}>
                <Input disabled={fieldsDisabled?.dadosBancario?.descricao ?? undefined} />
            </Form.Item>
        </Col>

        {
            codTipoForm === EnumDadoBancarioTipo.Conta && <>
                <Col xs={24} sm={12} md={9} lg={10} xl={5} xxl={5}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioConta>> name={[...nameParent, "codBanco"]} label="Banco" rules={[{ required : true }]}>
                        <BancoSelect />
                    </Form.Item>
                </Col>
                <Col xs={16} sm={8} md={6} lg={6} xl={3} xxl={3}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioConta>> name={[...nameParent, "numeroAgencia"]} label="Agência" rules={[{ max: 30 }, { required : true }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={8} sm={4} md={6} lg={6} xl={2} xxl={2}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioConta>> name={[...nameParent, "dacAgencia"]} label="Díg." rules={[{ max: 5 }, { required : false }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={16} sm={8} md={6} lg={6} xl={3} xxl={3}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioConta>> name={[...nameParent, "numeroConta"]} label="Conta" rules={[{ max: 30 }, { required : true }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={8} sm={4} md={6} lg={6} xl={2} xxl={2}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioConta>> name={[...nameParent, "dacConta"]} label="Díg." rules={[{ max: 5 }, { required : false }]}>
                        <Input />
                    </Form.Item>
                </Col>
            </>
        }
        {
            codTipoForm === EnumDadoBancarioTipo.ChavePix && <>
                <Col xs={24} sm={16} md={9} lg={10} xl={6} xxl={6}>
                    <Form.Item<IDadosBancarioFormInstanceType<DadosBancarioPix>> name={[...nameParent, "chavePix"]} label="Chave" rules={[{ max: 256 }, { required : true }]}>
                        <Input disabled={(fieldsDisabled?.dadosBancario as BooleanProps<DadosBancarioPix>)?.chavePix ?? undefined} />
                    </Form.Item>
                </Col>
            </>
        }
    </Row>
}